"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
// import ReactTooltip from 'react-tooltip';
const lodash_1 = __importDefault(require("lodash"));
const material_1 = require("@mui/material");
const checkLabel = (text, label) => lodash_1.default.isInteger(lodash_1.default.parseInt(label)) || lodash_1.default.isNil(label)
    ? text : `${text} ${label}`;
exports.default = (0, mobx_react_1.observer)(({ onlyIcon = false, disabled = false, content = null, type = 'button', className, onClick, text, label, icon, }) => (react_1.default.createElement(material_1.Tooltip, { title: checkLabel(text, label), placement: "top" },
    react_1.default.createElement("button", { type: type, disabled: disabled, onClick: onClick, className: className }, content ||
        react_1.default.createElement("span", null,
            react_1.default.createElement("i", { className: `fa fa-${icon}` }),
            !onlyIcon && react_1.default.createElement("b", { className: "dn di-ns" },
                " ",
                checkLabel(text, label)))))));
